<template>
    <div>
        <!----內部子選單 --->
        <div class="result_top">
            <!--- 子選單 --->
            <div class="lottoy_subMenu">
                <div 
                    v-for="(item,index) in subMenu" :key="index"
                    class="subMenu_btn"
                    :class="[`${$route.params.name}`,{'active':currentsubMenuIndex == index}]" 
                   
                    @click="changeSubMenu(index)">
                    {{item}}
                </div>    
            </div>  
        </div>
        <!--- 顯示結果 --->
        <div id="posChart" :style="{width: '100%', height: '984px'}"></div>	
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment-timezone';
import { getLotteryHistory } from '@/api/api';
export default {
    components:{
  
    },
    props:{
        currentTab:{
            type: String
        }
    },
    watch: {
        '$route': {
            handler: function(to, from) {
                this.currentsubMenuIndex =0;
                this.getAllData();
            },
            //immediate: true
        } 
    },
    data(){
        return{
            allData:[],
            periodData:[100,300,500],
            period:100,
            subMenu:[],
            currentsubMenuIndex:0,
            myChart:null,
            timer: null,           
        }
    },
    computed: {
        ...mapState([
            "baseInfo",
            "lotteryDrawTime"
        ]),
    },
    methods: {  
        // 查詢所有資料
        async getAllData(){ 
            
            try{
                const result = await getLotteryHistory(this.$route.params.name,1,20);
                this.allData = result.data;
                this.getSubMenu(); 
            }catch(e){
                
            } 
        },
		// 獲取目前應對應資料
        outputData(){ 
			// 球的位置 = 現在點子選單的index
			let ballPos = this.currentsubMenuIndex;
			let curSubTabAllPost = [];
			let curSubTabAllData = [];
			this.allData.forEach((item,index)=>{
				curSubTabAllPost.push(item.draw.split(',')[ballPos]);
				curSubTabAllData.push(moment(item.draw_time).format('MM/DD'))
			})
		
            // 判斷是不是特碼，如果是特碼顏色會不一樣
            let color = this.subMenu[this.currentsubMenuIndex].indexOf('特码') > -1 ? '#df0d15' :'#0380d8'
			let option = this.setLineChartOption(curSubTabAllData,curSubTabAllPost,color);

			// 绘制图表
			this.myChart.setOption(option)
        },
		// 折線圖設定
        setLineChartOption(xAxisData,seriesData,color){
			var option = {
				xAxis: {
					name: "日期",
					type: "category",
					data: xAxisData,
					boundaryGap: false,
					nameLocation: "end",
					offset: 20,
                    inverse: true, // 倒過來
                    axisLabel: {
                        fontSize: 16,
                        alignWithLabel: true
                    },
                    nameLocation: "start",
					min: 0,
                    max:20, 
                    nameTextStyle: {
                        align: "center",
                        verticalAlign: "top",
                        lineHeight: 120,
						fontSize: 14
						
                    },
					nameGap: 0,
				},
				yAxis: {
					name: "球号",
					type: 'value',
					nameLocation: "end",
                     axisLabel: {
                        fontSize: 16
                    },
					axisLine: {
						show: true,
						onZero: true
					},
                    nameTextStyle: {
                        verticalAlign: "bottom",
						fontSize: 14,
                        padding: [0, 37, 0, 0]
                    },
                    nameGap: 30
				},
				series: [{
					data: seriesData,
					type: "line",
					symbol: "circle",
					symbolSize: 35,
					label: {
						show: true,
						position: "inside",
						backgroundColor: null,
						fontSize: 20,
						verticalAlign: "middle",
						offset: [0, 1.8],
					},
					itemStyle: {
						color: color
					}
				}],
				grid: {
                    left:40,
                    right:40,
                    containLabel: true
                },
			}
            return option;
        },
		// 獲取全部子選單
        getSubMenu(){
            this.subMenu = this.$lotteryConfig[this.$route.params.name].mainMenu[this.currentTab].subMenu;
            this.outputData();
        },
		// 切換子選單
        changeSubMenu(index){
            this.currentsubMenuIndex = index;
            this.outputData();

        },    
	},
 
   
    mounted(){
        this.myChart = this.$echarts.init(document.getElementById('posChart'));
        this.getAllData();  
        this.timer = setInterval(()=>{
            if(this.lotteryDrawTime[this.$route.params.name] <= 0) {
                this.getAllData(); 
            }
        },1000) 
    },
    destroyed() {
        clearInterval(this.timer);
    }
   
}
</script>
<style lang="scss" scoped>
.result_top{
    align-items: center;
    display: flex;
    justify-content: space-between;
    .right{
        font-size:14px ;
        .statistics_period{
           color: #646363;
        }
        .period{
            cursor: pointer;
            margin-left: 32px;
            &.active{
                color: #14459c;
                font-weight: 800;
            }
        }
    }
}

// 子選單
.lottoy_subMenu{
    box-sizing: border-box;
    display: flex;
    .subMenu_btn{
        cursor: pointer;
        display: inline-block;
        color: #5a99c6;
        font-size: 14px;
        width: 90px;
        height: 32px;
        border: 1px solid #5a99c6;
        line-height: 32px;
        text-align: center;
        border-radius: 50px;
        margin-right: 16px;
        &:last-child{
            color: #c65a5a;
            border: 1px solid #c65a5a;
        }
       
        &:hover{
            color: #ffe6cc !important;
            background: #001236;
        }
        &.active{
            color: #ffe6cc;
            background: #001236 !important;
        }
       
    }
}
#posChart{
    margin-top: 40px;
}

// // 歐洲百萬和澳大利亞百萬，特碼1和特碼2 都要紅色
.euromillions:nth-last-child(2),.ausaturdaylotto:nth-last-child(2){
    color: #c65a5a;
    border: 1px solid #c65a5a;
}
</style>
